<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Jira Service Desk" class="d-icon d-icon--jira-service-desk" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m13.322 9.894 5.441.034a.848.848 0 0 1 .674 1.358L11.407 22a5.707 5.707 0 0 1-1.155-7.983l3.07-4.123Z" :fill="`url(#${uniqueID}a)`"/><path d="m10.25 14.007-5.408-.034a.848.848 0 0 1-.674-1.355L12.118 2a5.707 5.707 0 0 1 1.154 7.983l-3.022 4.024Z" fill="#2684FF"/><defs><linearGradient :id="`${uniqueID}a`" x1="13.109" y1="10.695" x2="15.395" y2="17.607" gradientUnits="userSpaceOnUse"><stop stop-color="#0052CC"/><stop offset="1" stop-color="#2684FF"/></linearGradient></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconJiraServiceDesk',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: '500',
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(s),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
